import courier from './courier.svg';

const images = { courier };

export default images;
